module.exports = __webpack_public_path__ + "img/member13.ea3315fd.png";